import { useState } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { FiltersChangeFn } from "@components/pageHeader/filters/lib";
import { YearFilter } from "@components/general/YearFilter/YearFilter";
import { EntityFilter } from "@components/general/EntityFilter/EntityFilter";
import { Class } from "../../../../common/types/class";
import { CollapseIcon } from "../../../../icons";
import styles from "../ClassesSettings.module.scss";
import { PlainModal } from "../../../general/Modal/Modal";
import { Button } from "../../../general/Button/Button";
import { TablePageHeader } from "../../../pageHeader/TablePageHeader";
import { CreateClassModal } from "./CreateClassModal";

interface Props {
    collapsedClasses: Set<string>;
    setCollapsedClasses: (classes: Set<string>) => void;
    classes: Class[];
    search: string;
    setSearch: (search: string) => void;
    showHeaderTitle: boolean;
    filters: Pick<FiltersTypes, "start" | "end" | "entityIds">;
    onFiltersChange: FiltersChangeFn;
}

export const ClassesSettingsHeader: React.FC<Props> = ({
    collapsedClasses,
    setCollapsedClasses,
    classes,
    search,
    setSearch,
    showHeaderTitle,
    filters,
    onFiltersChange,
}) => {
    const onCollapseButtonClick = () => {
        if (collapsedClasses.size === 0) {
            setCollapsedClasses(
                new Set(
                    classes
                        .filter((c) => c.parentClassId === null)
                        .map((c) => c.id),
                ),
            );
        } else {
            setCollapsedClasses(new Set());
        }
    };

    const [showAddClassModal, setShowAddClassModal] = useState(false);

    return (
        <>
            {showHeaderTitle && (
                <header className="settings__header">
                    <h3>Classes</h3>
                </header>
            )}

            <TablePageHeader
                search={search}
                onSearchChange={(value) => {
                    setSearch(value ?? "");
                }}
            >
                <div className={styles.flexBox}>
                    <YearFilter filters={filters} onChange={onFiltersChange} />
                    <EntityFilter
                        filters={filters}
                        onChange={onFiltersChange}
                    />
                    <Button
                        variant="secondary"
                        icon
                        onClick={onCollapseButtonClick}
                    >
                        <CollapseIcon />
                    </Button>
                    <Button
                        className={styles.addClassButton}
                        onClick={() => setShowAddClassModal(true)}
                    >
                        Add class
                    </Button>
                </div>
            </TablePageHeader>

            <PlainModal
                show={showAddClassModal}
                onHide={() => setShowAddClassModal(false)}
            >
                <CreateClassModal
                    parentClassId={null}
                    onHide={() => setShowAddClassModal(false)}
                />
            </PlainModal>
        </>
    );
};
